var _style, _path, _path2, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWaceMainDark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "\\uB808\\uC774\\uC5B4_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 356 129",
  style: {
    enableBackground: "new 0 0 356 129"
  },
  xmlSpace: "preserve",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M35.5,0.2H55l9,98.8h0.4l9.5-98.8h22l9.5,98.8h0.4l9-98.8h17.4l-13,128.5H94.1L84.9,42h-0.4l-9.2,86.7H48.5 L35.5,0.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M146.4,0.3h27.4l20.9,128.5h-20.2l-3.7-25.5v0.4h-23l-3.7,25.2h-18.7L146.4,0.3z M168.4,86.2l-9-63.5h-0.4 l-8.8,63.5H168.4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M203.7,120.8c-4.9-5.4-7.4-12.9-7.4-22.7V31c0-9.8,2.5-17.3,7.4-22.7c4.9-5.4,12.1-8,21.5-8 c9.4,0,16.6,2.7,21.5,8c4.9,5.4,7.4,12.9,7.4,22.7v13.2h-18.6V29.8c0-7.7-3.3-11.6-9.8-11.6c-6.5,0-9.8,3.9-9.8,11.6v69.8 c0,7.6,3.3,11.4,9.8,11.4c6.5,0,9.8-3.8,9.8-11.4V80.5h18.6v17.7c0,9.8-2.5,17.3-7.4,22.7c-4.9,5.4-12.1,8-21.5,8 C215.8,128.9,208.7,126.2,203.7,120.8z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M263.5,0.3h55.1v18.4h-34.9v34h27.7V71h-27.7v39.5h34.9v18.4h-55.1V0.3z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 8.3,
  y: 109.8,
  transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -110.013 137.3107)",
  className: "st0",
  width: 10.7,
  height: 27.8
}), /*#__PURE__*/React.createElement("rect", {
  x: -0.2,
  y: 10.8,
  className: "st0",
  width: 10.7,
  height: 107.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 8.3,
  y: -8.4,
  transform: "matrix(6.123234e-17 -1 1 6.123234e-17 8.1383 19.1594)",
  className: "st0",
  width: 10.7,
  height: 27.8
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 337,
  y: -8.5,
  transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 347.6893 -337.013)",
  className: "st0",
  width: 10.7,
  height: 27.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 345.6,
  y: 10.7,
  transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 701.7844 128.8276)",
  className: "st0",
  width: 10.7,
  height: 107.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 337,
  y: 109.6,
  transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 465.8406 -218.8617)",
  className: "st0",
  width: 10.7,
  height: 27.8
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWaceMainDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wace-main-dark.1f1bc584e27b225df4587ee427a8049b.svg";